// SN DTC - Theme Event SDK
// INSTALL: Shopify admin -> Online Store -> Themes -> Edit code -> Assets.
// Paste/upload this file as a theme asset and load it only where non-native
// strategic events are needed. Native Shopify funnel events remain owned by
// the installed SN-RudderStack Custom Pixel; do not replace that Pixel with the
// Gateway-only migration candidate during this release.
(function () {
  "use strict";

  var EVENT_GATEWAY_URL = "https://ceg.snnc.cc";
  var ANON_KEY = "sn_anon_id";
  var FIRST_TOUCH_KEY = "sn_first_touch";
  var CAMPAIGN_CLICKED_KEY = "sn_campaign_clicked";
  var TRACKING_PLAN_VERSION = "v2";
  var LIBRARY = { name: "sn-theme-event-sdk", version: "2.0.0" };
  var GA_ID_TIMEOUT_MS = 250;
  var CLICK_IDS = ["gclid", "fbclid", "ttclid", "ScCid", "msclkid", "twclid"];
  var HASHED_KEYS = {
    emailhash: true,
    email_hash: true,
    phonehash: true,
    phone_hash: true,
  };
  var RESERVED_EVENT_INPUT_KEYS = {
    event_id: true, event_key: true, event_name: true, event_class: true,
    event_version: true, event_revision: true, tracking_plan_version: true,
    store_id: true, shopify_domain: true, shopify_shop: true, environment: true, occurred_at: true,
    collector: true, __sn_dtc_skip_rudder: true,
  };
  var DECLARATIVE_EVENTS = {
    "Navigation Clicked": true,
    "Navigation Closed": true,
    "Hero Displayed": true,
    "Hero Viewed": true,
    "Hero Clicked": true,
    "Banner Viewed": true,
    "Banner Clicked": true,
    "Section Displayed": true,
    "Section Viewed": true,
    "Section Clicked": true,
    "FAQ Displayed": true,
    "FAQ Viewed": true,
    "FAQ Item Displayed": true,
    "FAQ Item Viewed": true,
    "FAQ Item Clicked": true,
    "Category Viewed": true,
    "Category Clicked": true,
    "Product Card Viewed": true,
    "Product Card Clicked": true,
    "Review Card Viewed": true,
    "Review Card Clicked": true,
    "Review Carousel Interaction": true,
    "Video Card Viewed": true,
    "Video Card Clicked": true,
    "Cart Interaction": true,
    "Accessory Viewed": true,
    "Accessory Added": true,
    "CTA Clicked": true,
    "Email Subscribed": true,
    "Financing Viewed": true,
    "Promotion Viewed": true,
    "Promotion Clicked": true,
    "Reviews Viewed": true,
    "SMS Subscribed": true,
    "Chat Started": true,
    "Product Option Viewed": true,
    "Product Option Selected": true,
    "Quiz Displayed": true,
    "Quiz Viewed": true,
    "Guide Clicked": true,
  };
  var PII_KEY_PARTS = ["email", "phone", "tel", "address", "street", "city", "zip", "postal", "firstname", "lastname", "fullname", "customer", "userid", "anonymous", "session", "identity", "password", "state", "country", "ip"];
  var BUSINESS_ID_KEYS = {
    bannerid: true, categoryid: true, ctaid: true, faqid: true, heroid: true,
    mediaid: true, productid: true, promoid: true, reviewid: true, sectionid: true,
    videoid: true, variantid: true, collectionid: true,
  };
  var RAW_EMAIL_VALUE = /\b[^\s@]+@[^\s@]+\.[^\s@]+\b/;
  var RAW_PHONE_VALUE = /^\+?\d[\d ()-]{7,}\d$/;
  var CONTROL_CHARACTER = /[\u0000-\u001f\u007f]/;
  var UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var MAX_BUSINESS_ID_LENGTH = 256;
  var MAX_PII_SCAN_DEPTH = 5;
  var UTM_MAP = {
    utm_source: "source",
    utm_medium: "medium",
    utm_campaign: "name",
    utm_term: "term",
    utm_content: "content",
    utm_creator: "creator",
  };
  var runtimeCampaignClicked = {};
  var ANALYTICS_CONFIG = window.SNDTCAnalyticsConfig || {};
  var PRODUCT_MEDIA_CONFIG = window.SNDTCProductMediaConfig || {};
  var CLIENT_EVENT_CONTRACT = window.SNDTCClientEventContract || { events: [] };
  var STORE_ID = ANALYTICS_CONFIG.store_id || "sweetnight-us";
  var SHOPIFY_STORE_DOMAIN = ANALYTICS_CONFIG.shopify_domain || "www.sweetnight.com";
  var GA4_MEASUREMENT_ID = ANALYTICS_CONFIG.ga4_measurement_id || PRODUCT_MEDIA_CONFIG.ga4_measurement_id || "G-0RXGLTMNBX";

  function consentAllows() {
    return !!(window.__snConsent && window.__snConsent.analytics === true);
  }

  function setAnalyticsConsent(allowed) {
    window.__snConsent = window.__snConsent || {};
    window.__snConsent.analytics = allowed === true;
    return window.__snConsent.analytics;
  }

  function initializeCustomerPrivacy() {
    if (!window.__snConsent || typeof window.__snConsent.analytics !== "boolean") setAnalyticsConsent(false);
    function syncFromApi() {
      try {
        var api = window.Shopify && window.Shopify.customerPrivacy;
        if (api && typeof api.analyticsProcessingAllowed === "function") {
          setAnalyticsConsent(api.analyticsProcessingAllowed() === true);
          return true;
        }
      } catch (e) {
        setAnalyticsConsent(false);
      }
      return false;
    }
    if (!syncFromApi() && window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      try {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
          if (error || !syncFromApi()) setAnalyticsConsent(false);
        });
      } catch (e) {
        setAnalyticsConsent(false);
      }
    }
    if (document && typeof document.addEventListener === "function") {
      document.addEventListener("visitorConsentCollected", function (event) {
        setAnalyticsConsent(!!(event && event.detail && event.detail.analyticsAllowed === true));
      });
    }
  }

  function uuid() {
    try {
      if (window.crypto && window.crypto.randomUUID) {
        var generated = window.crypto.randomUUID();
        if (isValidUuid(generated)) return generated;
      }
    } catch (e) {}
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function isValidUuid(value) {
    return typeof value === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
  }

  function cookieGet(name) {
    var prefix = encodeURIComponent(name) + "=";
    var parts = (document.cookie || "").split("; ");
    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].indexOf(prefix) === 0) {
        return decodeURIComponent(parts[i].slice(prefix.length));
      }
    }
    return "";
  }

  function cookieSet(name, value) {
    var expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie =
      encodeURIComponent(name) +
      "=" +
      encodeURIComponent(value) +
      "; expires=" +
      expires +
      "; path=/; SameSite=Lax; Secure";
  }

  function storageGet(key) {
    try {
      return window.localStorage && window.localStorage.getItem(key);
    } catch (e) {
      return "";
    }
  }

  function storageSet(key, value) {
    try {
      if (window.localStorage) window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function sessionGet(key) {
    try {
      return window.sessionStorage && window.sessionStorage.getItem(key);
    } catch (e) {
      return "";
    }
  }

  function sessionSet(key, value) {
    try {
      if (window.sessionStorage) window.sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function getPersisted(key) {
    return cookieGet(key) || storageGet(key) || "";
  }

  function setPersisted(key, value) {
    cookieSet(key, value);
    storageSet(key, value);
  }

  function getAnonymousId() {
    var value = getPersisted(ANON_KEY);
    if (!UUID_PATTERN.test(String(value || ""))) {
      value = uuid();
      setPersisted(ANON_KEY, value);
    }
    return value;
  }

  function currentUrl() {
    return sanitizeUrl(window.location ? window.location.href : "");
  }

  function currentPage() {
    return {
      url: currentUrl(),
      path: window.location ? window.location.pathname : "",
      search: sanitizeSearch(window.location ? window.location.search : ""),
      referrer: sanitizeReferrer(document.referrer || ""),
      title: document.title || "",
    };
  }

  function parseQuery(search) {
    var out = {};
    var query = (search || "").replace(/^\?/, "");
    if (!query) return out;
    var pairs = query.split("&");
    for (var i = 0; i < pairs.length; i += 1) {
      if (!pairs[i]) continue;
      var splitAt = pairs[i].indexOf("=");
      var rawKey = splitAt < 0 ? pairs[i] : pairs[i].slice(0, splitAt);
      var rawValue = splitAt < 0 ? "" : pairs[i].slice(splitAt + 1);
      try {
        out[decodeURIComponent(rawKey)] = decodeURIComponent(rawValue.replace(/\+/g, " "));
      } catch (e) {
        out[rawKey] = rawValue;
      }
    }
    return out;
  }

  function encodeQueryValue(value) {
    return encodeURIComponent(value).replace(/%20/g, "+");
  }

  function normalizedKey(key) {
    return String(key || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
  }

  function isAllowedHashedKey(key) {
    var normalized = normalizedKey(key);
    return !!(HASHED_KEYS[normalized] || HASHED_KEYS[String(key || "").toLowerCase()]);
  }

  function isAllowedBusinessIdKey(key) {
    return !!BUSINESS_ID_KEYS[normalizedKey(key)];
  }

  function isRawPiiKey(key) {
    var normalized = normalizedKey(key);
    if (!normalized || isAllowedHashedKey(key)) return false;
    for (var i = 0; i < PII_KEY_PARTS.length; i += 1) {
      if (normalized.indexOf(PII_KEY_PARTS[i]) !== -1) return true;
    }
    return false;
  }

  function decodePiiValue(value) {
    try {
      return decodeURIComponent(String(value || "").replace(/\+/g, " "));
    } catch (e) {
      return String(value || "");
    }
  }

  // Reject rather than strip PII from caller input. Stripping could let GA4
  // observe an event that the Gateway would later reject.
  function hasUnsafePii(value, seen, depth, key) {
    var allowedHash;
    var allowedBusinessId;
    var childKey;
    var decoded;
    // Undefined optional fields are equivalent to absent fields. In
    // particular, do this before key validation so an omitted optional PII
    // field cannot turn an otherwise valid event into an unsafe one.
    if (value === undefined) return false;
    if (depth > MAX_PII_SCAN_DEPTH) return true;
    if (key) {
      allowedHash = isAllowedHashedKey(key);
      if (isRawPiiKey(key)) return true;
      if (allowedHash) return typeof value !== "string" || !/^[a-f0-9]{64}$/i.test(value);
      allowedBusinessId = isAllowedBusinessIdKey(key);
      if (allowedBusinessId && typeof value !== "string" && typeof value !== "number") return true;
    }
    if (value === null || typeof value === "boolean") return false;
    if (typeof value === "number") return !isFinite(value);
    if (typeof value === "string") {
      decoded = decodePiiValue(value);
      if (RAW_EMAIL_VALUE.test(decoded)) return true;
      if (allowedBusinessId && (!decoded || decoded.length > MAX_BUSINESS_ID_LENGTH || CONTROL_CHARACTER.test(decoded))) return true;
      if (allowedBusinessId && /^\d+$/.test(decoded.trim())) return false;
      return RAW_PHONE_VALUE.test(decoded.trim());
    }
    if (!value || typeof value !== "object") return true;
    seen = seen || [];
    if (seen.indexOf(value) !== -1) return true;
    seen.push(value);
    if (Object.prototype.toString.call(value) === "[object Array]") {
      for (var i = 0; i < value.length; i += 1) {
        if (hasUnsafePii(value[i], seen, depth + 1)) {
          seen.pop();
          return true;
        }
      }
      seen.pop();
      return false;
    }
    for (childKey in value) {
      if (Object.prototype.hasOwnProperty.call(value, childKey) && hasUnsafePii(value[childKey], seen, depth + 1, childKey)) {
        seen.pop();
        return true;
      }
    }
    seen.pop();
    return false;
  }

  function hasUnsafeCustomInput(properties) {
    var key;
    properties = properties || {};
    if (!properties || typeof properties !== "object" || Object.prototype.toString.call(properties) === "[object Array]") return hasUnsafePii(properties, [], 0);
    for (key in properties) {
      if (!Object.prototype.hasOwnProperty.call(properties, key) || RESERVED_EVENT_INPUT_KEYS[key]) continue;
      if (hasUnsafePii(properties[key], [], 0, key)) return true;
    }
    return false;
  }

  function sanitizeSearch(search) {
    var query = parseQuery(search);
    var parts = [];
    var key;
    for (key in query) {
      if (!Object.prototype.hasOwnProperty.call(query, key)) continue;
      if (!Object.prototype.hasOwnProperty.call(UTM_MAP, key) && CLICK_IDS.indexOf(key) === -1 && key !== "sc_cid") continue;
      if (isRawPiiKey(key) || !safeContextValue(query[key], 128)) continue;
      parts.push(encodeURIComponent(key) + "=" + encodeQueryValue(query[key]));
    }
    return parts.length ? "?" + parts.join("&") : "";
  }

  function safeContextValue(value, maxLength) {
    var decoded = decodePiiValue(value);
    return typeof value === "string" && decoded.length > 0 && decoded.length <= maxLength &&
      !CONTROL_CHARACTER.test(decoded) && !RAW_EMAIL_VALUE.test(decoded) && !RAW_PHONE_VALUE.test(decoded);
  }

  function sanitizePath(path) {
    var value = String(path || "").split(/[?#]/, 1)[0];
    if (!value || !safeContextValue(value, 512)) return "/";
    return value.charAt(0) === "/" ? value : "/" + value;
  }

  function sanitizeReferrer(referrer) {
    var value = String(referrer || "").split(/[?#]/, 1)[0];
    if (!value || !safeContextValue(value, 1024)) return "";
    return value;
  }

  function sanitizeUrl(url) {
    var value = String(url || "");
    var hashIndex = value.indexOf("#");
    // Fragments are not needed for attribution and may contain free text or
    // tokens; never carry them into a canonical context or event property.
    var hash = "";
    var withoutHash = hashIndex >= 0 ? value.slice(0, hashIndex) : value;
    var queryIndex = withoutHash.indexOf("?");
    if (queryIndex < 0) return value;
    return withoutHash.slice(0, queryIndex) + sanitizeSearch(withoutHash.slice(queryIndex)) + hash;
  }

  function parseCampaignFromLocation() {
    var query = parseQuery(window.location ? window.location.search : "");
    var campaign = {};
    var clickIds = {};
    var raw = {};
    var key;

    for (key in UTM_MAP) {
      if (Object.prototype.hasOwnProperty.call(UTM_MAP, key) && safeContextValue(query[key], 128)) {
        campaign[UTM_MAP[key]] = query[key];
        raw[key] = query[key];
      }
    }
    for (var i = 0; i < CLICK_IDS.length; i += 1) {
      key = CLICK_IDS[i];
      if (safeContextValue(query[key], 128)) {
        var canonicalClickId = key === "ScCid" ? "sc_cid" : key;
        clickIds[canonicalClickId] = query[key];
        raw[canonicalClickId] = query[key];
      }
    }

    return { campaign: campaign, clickIds: clickIds, raw: raw };
  }

  function hasAttribution(value) {
    return !!(
      value &&
      (Object.keys(value.campaign || {}).length || Object.keys(value.clickIds || {}).length)
    );
  }

  function getFirstTouch() {
    var saved = getPersisted(FIRST_TOUCH_KEY);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {}
    }

    var current = parseCampaignFromLocation();
    if (hasAttribution(current)) {
      setPersisted(FIRST_TOUCH_KEY, JSON.stringify(current));
    }
    return current;
  }

  function contextNavigator() {
    return typeof navigator === "undefined" ? {} : navigator;
  }

  function boundedNumber(value, max) {
    var number = Number(value);
    return isFinite(number) && number > 0 && number <= max ? Math.round(number) : undefined;
  }

  function clientContext(anonymousId) {
    var firstTouch = getFirstTouch();
    var nav = contextNavigator();
    var page = currentPage();
    var output = {
      anonymous_id: anonymousId,
      page_path: sanitizePath(page.path),
      page_referrer: page.referrer,
      language: safeContextValue(String(nav.language || ""), 35) ? String(nav.language).toLowerCase() : undefined,
      user_agent: safeContextValue(String(nav.userAgent || ""), 512) ? String(nav.userAgent) : undefined,
      client_id_status: "pending",
      session_id_status: "pending",
    };
    var screen = window.screen || {};
    var viewportWidth = boundedNumber(window.innerWidth, 10000);
    var viewportHeight = boundedNumber(window.innerHeight, 10000);
    var screenWidth = boundedNumber(screen.width, 10000);
    var screenHeight = boundedNumber(screen.height, 10000);
    var key;

    if (screenWidth !== undefined) output.screen_width = screenWidth;
    if (screenHeight !== undefined) output.screen_height = screenHeight;
    if (viewportWidth !== undefined) output.viewport_width = viewportWidth;
    if (viewportHeight !== undefined) output.viewport_height = viewportHeight;
    if (safeContextValue(firstTouch.campaign && firstTouch.campaign.source, 128)) output.utm_source = firstTouch.campaign.source;
    if (safeContextValue(firstTouch.campaign && firstTouch.campaign.medium, 128)) output.utm_medium = firstTouch.campaign.medium;
    if (safeContextValue(firstTouch.campaign && firstTouch.campaign.name, 128)) output.utm_campaign = firstTouch.campaign.name;
    return output;
  }

  function sanitizeProperties(value) {
    var output;
    var key;

    if (!value || typeof value !== "object") return value;

    if (Object.prototype.toString.call(value) === "[object Array]") {
      output = [];
      for (var i = 0; i < value.length; i += 1) {
        output.push(sanitizeProperties(value[i]));
      }
      return output;
    }

    output = {};
    for (key in value) {
      if (!Object.prototype.hasOwnProperty.call(value, key)) continue;
      if (value[key] === undefined) continue;
      if (isRawPiiKey(key)) continue;
      output[key] = sanitizeProperties(value[key]);
    }
    return output;
  }

  function gatewayUrl() {
    var config = window.SNDTCAnalyticsConfig || {};
    var mediaConfig = window.SNDTCProductMediaConfig || {};
    return String(config.event_gateway_url || mediaConfig.event_gateway_url || EVENT_GATEWAY_URL || "");
  }

  function isPlaceholderConfiguration(value) {
    return /^__[^_]+__$/.test(String(value || "").trim());
  }

  function isValidStoreId(value) {
    return !isPlaceholderConfiguration(value) && /^[a-z0-9][a-z0-9_-]{0,63}$/i.test(String(value || ""));
  }

  function isValidShopifyDomain(value) {
    return !isPlaceholderConfiguration(value) && /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i.test(String(value || ""));
  }

  function isValidGatewayUrl(value) {
    var text = String(value || "");
    var authority;
    var hostname;
    var portIndex;
    var port;
    if (isPlaceholderConfiguration(text) || !/^https:\/\/[^\s/?#]+\/?$/i.test(text)) return false;
    authority = text.slice(8).replace(/\/$/, "");
    if (!authority || authority.indexOf("@") !== -1) return false;
    hostname = authority;
    portIndex = authority.lastIndexOf(":");
    if (portIndex !== -1) {
      hostname = authority.slice(0, portIndex);
      port = authority.slice(portIndex + 1);
      if (!/^\d{1,5}$/.test(port) || Number(port) < 1 || Number(port) > 65535) return false;
    }
    return isValidShopifyDomain(hostname);
  }

  function ga4MeasurementId() {
    return String((window.SNDTCAnalyticsConfig || {}).ga4_measurement_id || (window.SNDTCProductMediaConfig || {}).ga4_measurement_id || GA4_MEASUREMENT_ID || "");
  }

  function isValidGa4MeasurementId(value) {
    return !isPlaceholderConfiguration(value) && /^G-[A-Z0-9]+$/i.test(String(value || ""));
  }

  // All destination prerequisites must pass before a UUID or envelope exists.
  function deliveryConfiguration(storeId, shopifyDomain) {
    if (!consentAllows()) return { skipped: true, reason: "consent" };
    if (!isValidStoreId(storeId) || !isValidShopifyDomain(shopifyDomain)) return { skipped: true, reason: "store_unconfigured" };
    if (!isValidGatewayUrl(gatewayUrl())) return { skipped: true, reason: "gateway_unconfigured" };
    if (typeof window.fetch !== "function") return { skipped: true, reason: "fetch_unavailable" };
    return null;
  }

  function postGateway(envelope) {
    if (!approvedClientEnvelope(envelope)) return { skipped: true, reason: "client_contract" };
    if (!consentAllows()) return { skipped: true, reason: "consent" };
    if (!window.fetch) return { skipped: true, reason: "fetch_unavailable" };
    var url = gatewayUrl();
    if (!isValidGatewayUrl(url)) return { skipped: true, reason: "gateway_unconfigured" };
    return window.fetch(url.replace(/\/$/, "") + "/v1/events", {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(envelope),
    });
  }

  function canonicalEventName(event) {
    return String(event || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .slice(0, 40);
  }

  function contractEvent(eventKey) {
    var events = CLIENT_EVENT_CONTRACT && CLIENT_EVENT_CONTRACT.events;
    var i;
    if (!events || !Array.isArray(events)) return null;
    for (i = 0; i < events.length; i += 1) {
      if (events[i] && events[i].event_key === eventKey) return events[i];
    }
    return null;
  }

  function hasRequiredProperties(properties, required) {
    var i;
    var value;
    if (!Array.isArray(required)) return false;
    for (i = 0; i < required.length; i += 1) {
      value = properties[required[i]];
      if (value === undefined || value === null || value === "") return false;
    }
    return true;
  }

  function hasOnlyAllowedProperties(properties, allowed) {
    var key;
    if (!Array.isArray(allowed)) return false;
    for (key in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, key) && allowed.indexOf(key) === -1) return false;
    }
    return true;
  }

  function approvedClientEnvelope(envelope) {
    var definition = contractEvent(envelope && envelope.event_key);
    var schemaVersion = Number(CLIENT_EVENT_CONTRACT && CLIENT_EVENT_CONTRACT.schema_version);
    return !!(Number.isInteger(schemaVersion) && schemaVersion > 0 && definition && definition.event_class === "custom_browser" && envelope && envelope.event_class === "custom_browser" &&
      envelope.event_version === schemaVersion &&
      envelope.tracking_plan_version === definition.tracking_plan_version &&
      envelope.event_revision === definition.event_revision &&
      hasRequiredProperties(envelope.properties || {}, definition.required_client_properties) &&
      hasOnlyAllowedProperties(envelope.properties || {}, definition.allowed_client_properties));
  }

  function clearTimer(timer) {
    if (timer !== undefined && typeof window.clearTimeout === "function") window.clearTimeout(timer);
  }

  function validGaClientId(value) {
    return safeContextValue(String(value || ""), 128) && /^[A-Za-z0-9._-]+$/.test(String(value));
  }

  function validGaSessionId(value) {
    var text = String(value || "");
    return typeof value === "string" && text.length > 0 && text.length <= 64 &&
      !CONTROL_CHARACTER.test(text) && !RAW_EMAIL_VALUE.test(text) && /^[A-Za-z0-9._-]+$/.test(text);
  }

  // Google tag's get API is callback-based and may never call back when the
  // tag is blocked or consent is withdrawn. Resolve all paths in a bounded
  // interval so the canonical Gateway POST cannot hang indefinitely.
  function collectGaIds() {
    var measurementId = ga4MeasurementId();
    var result = {
      client_id_status: "unavailable",
      session_id_status: "unavailable",
    };
    var get = typeof window.gtag === "function" ? window.gtag : null;
    if (!consentAllows()) {
      result.client_id_status = "consent_denied";
      result.session_id_status = "consent_denied";
      return Promise.resolve(result);
    }
    if (!isValidGa4MeasurementId(measurementId)) {
      result.client_id_status = "measurement_id_unconfigured";
      result.session_id_status = "measurement_id_unconfigured";
      return Promise.resolve(result);
    }
    if (!get) {
      result.client_id_status = "gtag_unavailable";
      result.session_id_status = "gtag_unavailable";
      return Promise.resolve(result);
    }
    return new Promise(function (resolve) {
      var remaining = 2;
      var settled = false;
      var timer;
      function finish() {
        if (settled) return;
        settled = true;
        clearTimer(timer);
        resolve(result);
      }
      function complete(field, value) {
        var valid = field === "client_id" ? validGaClientId(value) : validGaSessionId(value);
        var prefix = field === "client_id" ? "client_id" : "session_id";
        if (valid) {
          result[prefix] = String(value);
          result[prefix + "_status"] = "available";
        } else {
          result[prefix + "_status"] = value === undefined || value === null || value === "" ? "empty" : "invalid";
        }
        remaining -= 1;
        if (remaining <= 0) finish();
      }
      timer = typeof window.setTimeout === "function" ? window.setTimeout(function () {
        if (result.client_id_status === "unavailable") result.client_id_status = "timeout";
        if (result.session_id_status === "unavailable") result.session_id_status = "timeout";
        finish();
      }, GA_ID_TIMEOUT_MS) : undefined;
      ["client_id", "session_id"].forEach(function (field) {
        try {
          get("get", measurementId, field, function (value) { complete(field, value); });
        } catch (e) {
          complete(field, undefined);
          result[field === "client_id" ? "client_id_status" : "session_id_status"] = "error";
        }
      });
    });
  }

  function applyGaContext(envelope, ids) {
    var key;
    for (key in ids) {
      if (Object.prototype.hasOwnProperty.call(ids, key) && ids[key] !== undefined) envelope.client_context[key] = ids[key];
    }
    return envelope;
  }

  function contractSchemaVersion() {
    var value = Number(CLIENT_EVENT_CONTRACT && CLIENT_EVENT_CONTRACT.schema_version);
    return Number.isInteger(value) && value > 0 ? value : 0;
  }

  function configuredEnvironment() {
    var value = (window.SNDTCAnalyticsConfig || {}).environment || (window.SNDTCProductMediaConfig || {}).environment || "production";
    return value === "production" || value === "staging" || value === "development" ? value : "production";
  }

  function customProperties(value) {
    var output = {};
    var reserved = RESERVED_EVENT_INPUT_KEYS;
    var safe = sanitizeProperties(value || {});
    var key;
    for (key in safe) {
      if (Object.prototype.hasOwnProperty.call(safe, key) && key !== "properties" && !reserved[key]) output[key] = safe[key];
    }
    if (safe.properties && typeof safe.properties === "object" && !Array.isArray(safe.properties)) {
      for (key in safe.properties) {
        if (Object.prototype.hasOwnProperty.call(safe.properties, key)) output[key] = safe.properties[key];
      }
    }
    for (key in HASHED_KEYS) {
      if (Object.prototype.hasOwnProperty.call(output, key) && !/^[a-f0-9]{64}$/i.test(String(output[key] || ""))) delete output[key];
    }
    return output;
  }

  // This is the sole Theme-owned custom-event entrypoint. It creates one
  // canonical envelope before either destination sees it.
  function emitCustom(event, properties) {
    if (hasUnsafeCustomInput(properties)) return { envelope: null, delivery: { skipped: true, reason: "unsafe_pii" } };
    var input = sanitizeProperties(properties || {});
    var configuredStoreId = (window.SNDTCAnalyticsConfig || {}).store_id || STORE_ID;
    var configuredShopifyDomain = (window.SNDTCAnalyticsConfig || {}).shopify_domain ||
      (window.SNDTCProductMediaConfig || {}).shopify_domain || SHOPIFY_STORE_DOMAIN;
    var eventKey = canonicalEventName(event);
    if (!eventKey) return { envelope: null, delivery: { skipped: true, reason: "invalid_event_key" } };
    var definition = contractEvent(eventKey);
    var custom = customProperties(input);
    if (!definition || definition.event_class !== "custom_browser") return { envelope: null, delivery: { skipped: true, reason: "client_contract" } };
    if (!hasRequiredProperties(custom, definition.required_client_properties)) return { envelope: null, delivery: { skipped: true, reason: "missing_required_properties" } };
    if (!hasOnlyAllowedProperties(custom, definition.allowed_client_properties)) return { envelope: null, delivery: { skipped: true, reason: "client_contract" } };
    var configuration = deliveryConfiguration(configuredStoreId, configuredShopifyDomain);
    if (configuration) return { envelope: null, delivery: configuration };
    var anonymousId = getAnonymousId();
    var envelope = {
      event_id: uuid(),
      event_key: eventKey,
      event_class: "custom_browser",
      event_version: contractSchemaVersion(),
      tracking_plan_version: definition.tracking_plan_version,
      event_revision: definition.event_revision,
      store_id: configuredStoreId,
      shopify_domain: configuredShopifyDomain,
      environment: configuredEnvironment(),
      occurred_at: new Date().toISOString(),
      anonymous_id: anonymousId,
      client_context: clientContext(anonymousId),
      properties: custom,
    };
    var ga4 = { skipped: true, reason: "gateway_owner" };
    var delivery = collectGaIds().then(function (ids) {
      applyGaContext(envelope, ids);
      return postGateway(envelope);
    });
    return {
      envelope: envelope,
      delivery: delivery,
      ga4: ga4,
    };
  }

  // Compatibility surface: all legacy helpers still return the original
  // delivery result, but their writes now pass through emitCustom().
  function track(event, properties) {
    return emitCustom(event, properties).delivery;
  }

  // Compatibility-only: identity never leaves the browser through this SDK.
  function identify() {
    return { skipped: true, reason: "identity_not_supported" };
  }

  function strategicProperties(properties) {
    var output = {};
    var key;
    properties = properties || {};
    for (key in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, key)) output[key] = properties[key];
    }
    return output;
  }

  function emailSubscribed(properties) {
    properties = properties || {};
    var output = strategicProperties(properties);
    if (properties.emailHash) output.email_hash = properties.emailHash;
    delete output.emailHash;
    return track("Email Subscribed", output);
  }

  function smsSubscribed(properties) {
    properties = properties || {};
    var output = strategicProperties(properties);
    if (properties.phoneHash) output.phone_hash = properties.phoneHash;
    delete output.phoneHash;
    return track("SMS Subscribed", output);
  }

  function chatStarted(properties) {
    return track("Chat Started", strategicProperties(properties));
  }

  function promotionViewed(properties) {
    return track("Promotion Viewed", strategicProperties(properties));
  }

  function promotionClicked(properties) {
    return track("Promotion Clicked", strategicProperties(properties));
  }

  function reviewsViewed(properties) {
    return track("Reviews Viewed", strategicProperties(properties));
  }

  function financingViewed(properties) {
    return track("Financing Viewed", strategicProperties(properties));
  }

  function accessoryViewed(properties) {
    return track("Accessory Viewed", strategicProperties(properties));
  }

  function accessoryAdded(properties) {
    return track("Accessory Added", strategicProperties(properties));
  }

  function numeric(value) {
    var n = Number(value);
    return isFinite(n) ? n : undefined;
  }

  function videoProperties(properties) {
    var output = strategicProperties(properties || {});
    if (output.duration_seconds != null) output.duration_seconds = numeric(output.duration_seconds);
    if (output.position_seconds != null) output.position_seconds = numeric(output.position_seconds);
    if (output.percent != null) output.percent = numeric(output.percent);
    return output;
  }

  function videoPlaybackStarted(properties) {
    return track("Video Playback Started", videoProperties(properties));
  }

  function videoPlaybackProgressed(properties) {
    return track("Video Playback Progressed", videoProperties(properties));
  }

  function videoPlaybackPaused(properties) {
    return track("Video Playback Paused", videoProperties(properties));
  }

  function videoPlaybackCompleted(properties) {
    return track("Video Playback Completed", videoProperties(properties));
  }

  function pageEngaged(properties) {
    return track("Page Engaged", strategicProperties(properties));
  }

  function scrollDepthReached(properties) {
    return track("Scroll Depth Reached", strategicProperties(properties));
  }

  function sectionViewed(properties) {
    return track("Section Viewed", strategicProperties(properties));
  }

  function ctaClicked(properties) {
    return track("CTA Clicked", strategicProperties(properties));
  }

  // Variant option tracking is deliberately based on stable theme attributes.
  // A theme can mark each option control with data-sn-option and avoid scanning
  // the entire product form or sending events for mere hover/focus activity.
  function productOptionViewed(properties) {
    return track("Product Option Viewed", strategicProperties(properties));
  }

  function productOptionSelected(properties) {
    return track("Product Option Selected", strategicProperties(properties));
  }

  function datasetProps(el, prefix) {
    var output = {};
    var data = el && el.dataset ? el.dataset : {};
    var key;
    for (key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
      if (key.indexOf(prefix) !== 0) continue;
      var rawName = key.slice(prefix.length);
      if (!rawName) continue;
      var name = rawName.replace(/[A-Z]/g, function (m) { return "_" + m.toLowerCase(); });
      name = name.replace(/^_+/, "");
      output[name] = data[key];
    }
    return output;
  }

  function trackBehavior(eventName, properties) {
    if (!DECLARATIVE_EVENTS[eventName]) return { skipped: true, reason: "unknown_behavior_event" };
    return track(eventName, strategicProperties(properties));
  }

  // The two published themes share semantic class names but do not yet share
  // tracking attributes. Add only stable, component-level markers here so the
  // same SDK remains reusable for future stores without copying Liquid logic.
  function addThemeMarker(node, name, value) {
    if (!node || !node.getAttribute || !node.setAttribute || node.getAttribute(name)) return;
    node.setAttribute(name, value);
  }

  function annotateThemeDom() {
    if (typeof document === "undefined" || !document.querySelectorAll) return;
    var sections = document.querySelectorAll('[id^="shopify-section-"], main > section, main > div > section');
    for (var i = 0; i < sections.length; i += 1) {
      addThemeMarker(sections[i], "data-sn-section", sections[i].id || "theme-section-" + i);
    }

    var heroes = document.querySelectorAll(".x-container-slideshow, .kik-image-banner-container, .video-hero, .kiks-modification-slideshow, .kiks-modification-image-banner");
    for (var j = 0; j < heroes.length; j += 1) {
      addThemeMarker(heroes[j], "data-sn-track-display", "Hero Displayed");
      addThemeMarker(heroes[j], "data-sn-track-view", "Hero Viewed");
    }

    var banners = document.querySelectorAll(".promotion-banner, .promotion, .x-container-promotion-grid");
    for (var k = 0; k < banners.length; k += 1) {
      addThemeMarker(banners[k], "data-sn-track-display", "Banner Viewed");
      addThemeMarker(banners[k], "data-sn-track-view", "Banner Viewed");
    }

    var faqRoots = document.querySelectorAll(".faq-container, .section-kik-smart-faqs");
    for (var f = 0; f < faqRoots.length; f += 1) {
      addThemeMarker(faqRoots[f], "data-sn-track-display", "FAQ Displayed");
      addThemeMarker(faqRoots[f], "data-sn-track-view", "FAQ Viewed");
      var faqItems = faqRoots[f].querySelectorAll("button, summary, [role=button]");
      for (var fi = 0; fi < faqItems.length; fi += 1) {
        addThemeMarker(faqItems[fi], "data-sn-track-click", "FAQ Item Clicked");
        addThemeMarker(faqItems[fi], "data-sn-click-target", "faq_item");
      }
    }

    var reviews = document.querySelectorAll(".kik-review-card, .x-container-twm");
    for (var r = 0; r < reviews.length; r += 1) {
      addThemeMarker(reviews[r], "data-sn-track-view", "Review Card Viewed");
    }

    var cards = document.querySelectorAll(".card-product, .kik_product_card");
    for (var c = 0; c < cards.length; c += 1) {
      addThemeMarker(cards[c], "data-sn-track-view", "Product Card Viewed");
      addThemeMarker(cards[c], "data-sn-track-click", "Product Card Clicked");
      addThemeMarker(cards[c], "data-sn-click-target", "product_card");
    }

    var navLinks = document.querySelectorAll("header a[href], .shopify-header a[href], [data-mobile-navigation] a[href]");
    for (var n = 0; n < navLinks.length; n += 1) {
      addThemeMarker(navLinks[n], "data-sn-track-click", "Navigation Clicked");
      addThemeMarker(navLinks[n], "data-sn-click-target", "navigation");
    }

    var ctas = document.querySelectorAll(".x-container-slideshow a[href], .kik-image-banner-container a[href], .promotion-banner a[href], .promotion a[href]");
    for (var a = 0; a < ctas.length; a += 1) {
      addThemeMarker(ctas[a], "data-sn-track-click", "CTA Clicked");
      addThemeMarker(ctas[a], "data-sn-cta-id", ctas[a].id || "theme-cta-" + a);
      addThemeMarker(ctas[a], "data-sn-click-target", "cta");
    }

    var options = document.querySelectorAll("[name^=option], [name^=options], .variant-radio, [data-option-name], select[name*=option]");
    for (var o = 0; o < options.length; o += 1) addThemeMarker(options[o], "data-sn-option", "true");

    var videos = document.querySelectorAll(".video-hero video, .video-with-text-wrapper video, .video-frame video, .section-kik-video-slider video, .kiks-modification-slideshow video, .kiks-modification-image-banner video, [data-video-id]");
    for (var v = 0; v < videos.length; v += 1) {
      if (videos[v].getAttribute("data-sn-product-media-bound") === "true") continue;
      addThemeMarker(videos[v], "data-sn-video-id", videos[v].id || "theme-video-" + v);
      addThemeMarker(videos[v], "data-sn-video-source", "html5");
    }
  }

  function behaviorProperties(el) {
    var output = datasetProps(el, "sn");
    delete output.track_display;
    delete output.track_view;
    delete output.track_click;
    if (!output.destination && el.href) output.destination = sanitizeUrl(el.href);
    if (!output.click_target) output.click_target = el.getAttribute("data-sn-click-target") || undefined;
    return output;
  }

  function autoTrackDeclarativeBehavior() {
    if (window.__sndtcDeclarativeBehaviorTracked) return;
    window.__sndtcDeclarativeBehaviorTracked = true;
    var viewObserver = null;

    if (window.IntersectionObserver) {
      viewObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          var entry = entries[i];
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) continue;
          var node = entry.target;
          if (node.__sndtcDeclarativeViewed) continue;
          node.__sndtcDeclarativeViewed = true;
          trackBehavior(node.getAttribute("data-sn-track-view"), behaviorProperties(node));
          viewObserver.unobserve(node);
        }
      }, { threshold: [0.5] });
    }

    function nodes(root, selector) {
      var output = [];
      if (root && root.matches && root.matches(selector)) output.push(root);
      if (root && root.querySelectorAll) {
        var descendants = root.querySelectorAll(selector);
        for (var i = 0; i < descendants.length; i += 1) output.push(descendants[i]);
      }
      return output;
    }

    function scan(root) {
      var displayed = nodes(root, "[data-sn-track-display]");
      for (var i = 0; i < displayed.length; i += 1) {
        if (displayed[i].__sndtcDeclarativeDisplayed) continue;
        displayed[i].__sndtcDeclarativeDisplayed = true;
        trackBehavior(displayed[i].getAttribute("data-sn-track-display"), behaviorProperties(displayed[i]));
      }
      if (viewObserver) {
        var viewed = nodes(root, "[data-sn-track-view]");
        for (var j = 0; j < viewed.length; j += 1) {
          if (!viewed[j].__sndtcDeclarativeObserved) {
            viewed[j].__sndtcDeclarativeObserved = true;
            viewObserver.observe(viewed[j]);
          }
        }
      }
    }

    document.addEventListener("click", function (event) {
      var node = event.target;
      while (node && node !== document && !(node.getAttribute && node.getAttribute("data-sn-track-click"))) node = node.parentNode;
      if (!node || node === document) return;
      trackBehavior(node.getAttribute("data-sn-track-click"), behaviorProperties(node));
    }, true);

    scan(document);
    if (window.MutationObserver && document.documentElement) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          for (var j = 0; j < mutations[i].addedNodes.length; j += 1) scan(mutations[i].addedNodes[j]);
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function trackVideoElement(video, properties) {
    if (!video || video.__sndtcVideoTracked) return;
    video.__sndtcVideoTracked = true;

    var base = strategicProperties(properties || {});
    var milestones = [25, 50, 75, 90];
    var seen = {};
    var started = false;

    function props(extra) {
      var output = {};
      var key;
      for (key in base) output[key] = base[key];
      for (key in extra) output[key] = extra[key];
      output.duration_seconds = numeric(video.duration);
      output.position_seconds = numeric(video.currentTime);
      return output;
    }

    video.addEventListener("play", function () {
      if (started) return;
      started = true;
      videoPlaybackStarted(props({}));
    });

    video.addEventListener("timeupdate", function () {
      if (!video.duration || !isFinite(video.duration)) return;
      var pct = Math.floor((video.currentTime / video.duration) * 100);
      for (var i = 0; i < milestones.length; i += 1) {
        var m = milestones[i];
        if (pct >= m && !seen[m]) {
          seen[m] = true;
          videoPlaybackProgressed(props({ percent: m }));
        }
      }
    });

    video.addEventListener("pause", function () {
      if (video.ended) return;
      videoPlaybackPaused(props({}));
    });

    video.addEventListener("ended", function () {
      videoPlaybackCompleted(props({ percent: 100 }));
    });
  }

  function autoTrackVideos() {
    var nodes = document.querySelectorAll("[data-sn-video-id]");
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (node.getAttribute && node.getAttribute("data-sn-product-media-bound") === "true") continue;
      trackVideoElement(node, datasetProps(node, "sn"));
    }
  }

  function autoTrackScrollDepth() {
    if (window.__sndtcScrollTracked) return;
    window.__sndtcScrollTracked = true;
    var milestones = [25, 50, 75, 90];
    var seen = {};

    function maxScrollPercent() {
      var d = document.documentElement;
      var b = document.body;
      var scrollTop = window.pageYOffset || d.scrollTop || b.scrollTop || 0;
      var height = Math.max(d.scrollHeight || 0, b.scrollHeight || 0) - window.innerHeight;
      if (height <= 0) return 100;
      return Math.min(100, Math.floor((scrollTop / height) * 100));
    }

    function check() {
      var pct = maxScrollPercent();
      for (var i = 0; i < milestones.length; i += 1) {
        var m = milestones[i];
        if (pct >= m && !seen[m]) {
          seen[m] = true;
          scrollDepthReached({ percent: m, path: currentPage().path });
        }
      }
    }

    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    check();
  }

  function autoTrackSections() {
    if (!window.IntersectionObserver) return;
    var nodes = document.querySelectorAll("[data-sn-section]");
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        var entry = entries[i];
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) continue;
        var el = entry.target;
        if (el.__sndtcSectionViewed) continue;
        el.__sndtcSectionViewed = true;
        sectionViewed(datasetProps(el, "sn"));
        observer.unobserve(el);
      }
    }, { threshold: [0.5] });

    for (var j = 0; j < nodes.length; j += 1) observer.observe(nodes[j]);
  }

  function autoTrackCtas() {
    if (window.__sndtcCtaTracked) return;
    window.__sndtcCtaTracked = true;
    document.addEventListener("click", function (event) {
      var target = event.target;
      while (target && target !== document) {
        if (target.getAttribute && target.getAttribute("data-sn-cta-id")) {
          ctaClicked(datasetProps(target, "sn"));
          return;
        }
        target = target.parentNode;
      }
    }, true);
  }

  function optionProperties(el) {
    var output = datasetProps(el, "sn");
    if (!output.option_name) output.option_name = el.getAttribute("name") || el.getAttribute("data-option-name") || undefined;
    if (!output.option_value) output.option_value = el.value || el.getAttribute("data-option-value") || undefined;
    if (!output.product_id && window.SNDTCProduct && window.SNDTCProduct.id) output.product_id = window.SNDTCProduct.id;
    output.page_type = output.page_type || "product";
    return output;
  }

  function autoTrackProductOptions() {
    if (window.__sndtcProductOptionsTracked) return;
    window.__sndtcProductOptionsTracked = true;
    var nodes = document.querySelectorAll("[data-sn-option]");
    if (!nodes.length) return;

    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          var entry = entries[i];
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) continue;
          var node = entry.target;
          if (node.__sndtcOptionViewed) continue;
          node.__sndtcOptionViewed = true;
          productOptionViewed(optionProperties(node));
          observer.unobserve(node);
        }
      }, { threshold: [0.5] });
      for (var i = 0; i < nodes.length; i += 1) observer.observe(nodes[i]);
    }

    document.addEventListener("change", function (event) {
      var node = event.target;
      while (node && node !== document && !(node.getAttribute && node.getAttribute("data-sn-option") !== null)) node = node.parentNode;
      if (!node || node === document) return;
      var props = optionProperties(node);
      var value = props.option_value;
      var key = (props.option_name || "option") + ":" + (props.product_id || "") + ":" + String(value || "");
      if (node.__sndtcOptionLastValue === key) return;
      node.__sndtcOptionLastValue = key;
      productOptionSelected(props);
    }, true);
  }

  function autoTrackEngagement() {
    if (window.__sndtcEngagementTracked) return;
    window.__sndtcEngagementTracked = true;
    var startedAt = Date.now();
    var visibleStartedAt = document.hidden ? 0 : startedAt;
    var visibleMs = 0;
    var fired = {};
    var thresholds = [10, 30, 60, 120];

    function currentVisibleMs() {
      return visibleMs + (visibleStartedAt ? Date.now() - visibleStartedAt : 0);
    }

    function maxScrollPercent() {
      var d = document.documentElement;
      var b = document.body;
      var scrollTop = window.pageYOffset || d.scrollTop || b.scrollTop || 0;
      var height = Math.max(d.scrollHeight || 0, b.scrollHeight || 0) - window.innerHeight;
      if (height <= 0) return 100;
      return Math.min(100, Math.floor((scrollTop / height) * 100));
    }

    function emit(seconds, final) {
      pageEngaged({
        seconds: seconds,
        path: currentPage().path,
        max_scroll_percent: maxScrollPercent(),
        final: Boolean(final),
      });
    }

    function check() {
      var seconds = Math.floor(currentVisibleMs() / 1000);
      for (var i = 0; i < thresholds.length; i += 1) {
        var t = thresholds[i];
        if (seconds >= t && !fired[t]) {
          fired[t] = true;
          emit(t, false);
        }
      }
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden && visibleStartedAt) {
        visibleMs += Date.now() - visibleStartedAt;
        visibleStartedAt = 0;
        check();
      } else if (!document.hidden && !visibleStartedAt) {
        visibleStartedAt = Date.now();
      }
    });

    window.addEventListener("pagehide", function () {
      var seconds = Math.floor(currentVisibleMs() / 1000);
      if (seconds >= 5) emit(seconds, true);
    });

    window.setInterval(check, 5000);
  }

  function autoTrackBehavior() {
    if (typeof document === "undefined" || typeof window === "undefined") return;
    annotateThemeDom();
    autoTrackVideos();
    autoTrackScrollDepth();
    autoTrackSections();
    autoTrackCtas();
    autoTrackProductOptions();
    autoTrackDeclarativeBehavior();
    autoTrackEngagement();
  }

  function campaignDedupeId(attribution) {
    var page = currentPage();
    return JSON.stringify({
      path: page.path,
      search: page.search,
      raw: attribution.raw || {},
    });
  }

  function hasCampaignClicked(id) {
    var key = CAMPAIGN_CLICKED_KEY + ":" + id;
    if (sessionGet(key)) return true;
    return !!runtimeCampaignClicked[key];
  }

  function markCampaignClicked(id) {
    var key = CAMPAIGN_CLICKED_KEY + ":" + id;
    runtimeCampaignClicked[key] = true;
    sessionSet(key, "1");
  }

  function fireCampaignClicked() {
    var current = parseCampaignFromLocation();
    var id;
    var properties;

    if (!hasAttribution(current)) return null;
    if (!consentAllows()) return { skipped: true, reason: "consent" };
    if (!window.fetch) return { skipped: true, reason: "fetch_unavailable" };
    id = campaignDedupeId(current);
    if (hasCampaignClicked(id)) return { skipped: true, reason: "campaign_clicked_dedupe" };

    properties = sanitizeProperties(current.raw || {});
    properties.url = currentUrl();
    markCampaignClicked(id);
    return track("Campaign Clicked", properties);
  }

  window.SNDTC = {
    emitCustom: emitCustom,
    track: track,
    identify: identify,
    setAnalyticsConsent: setAnalyticsConsent,
    emailSubscribed: emailSubscribed,
    smsSubscribed: smsSubscribed,
    chatStarted: chatStarted,
    promotionViewed: promotionViewed,
    promotionClicked: promotionClicked,
    reviewsViewed: reviewsViewed,
    financingViewed: financingViewed,
    accessoryViewed: accessoryViewed,
    accessoryAdded: accessoryAdded,
    videoPlaybackStarted: videoPlaybackStarted,
    videoPlaybackProgressed: videoPlaybackProgressed,
    videoPlaybackPaused: videoPlaybackPaused,
    videoPlaybackCompleted: videoPlaybackCompleted,
    trackVideoElement: trackVideoElement,
    pageEngaged: pageEngaged,
    scrollDepthReached: scrollDepthReached,
    sectionViewed: sectionViewed,
    ctaClicked: ctaClicked,
    productOptionViewed: productOptionViewed,
    productOptionSelected: productOptionSelected,
    trackBehavior: trackBehavior,
    annotateThemeDom: annotateThemeDom,
    autoTrackBehavior: autoTrackBehavior,
  };

  initializeCustomerPrivacy();
  fireCampaignClicked();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", autoTrackBehavior);
  } else {
    autoTrackBehavior();
  }
})();
